import CancelIcon from "@mui/icons-material/Cancel";
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Button,
  Tab,
  Tabs,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Typography,
  Toolbar,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import _without from "lodash/without";
import { useParams } from "react-router-dom";
import { PropTypes } from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import SwipeableViews from "react-swipeable-views";
import { AppDataContext } from "../../common/appContext";
import { handleError } from "../../helper";
import { AdminPreferencesService } from "../../services/adminPref.Service";
import { LeaderDashboardService } from "../../services/leaderDashboard.Service";
import { PlayerProfileService } from "../../services/playerProfile.Service";
import CombineResultsAnthros from "./CombineResultsAnthros";
import CombineResultsSAA from "./CombineResultsSAA";
import CombineResultShootingDrills from "./CombineResultsShootingDrills";
// import ReactExport from "react-data-export";
import reactDom from "react-dom";
import {
  isShowUnitDrawer,
  anthrosStations,
  shootingStations,
  strengthAndAgilityStations,
} from "../../configs/AppSettings";

import { exportDataToExcel } from "../../sharedComponents/CustomExportToExcel";
import Helper from "../../common/Helper";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 6 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

var positionSelected = false;
var playerSelected = false;
var collegeSelected = false;
function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}
function getStyles1(name, pName, theme) {
  return {
    fontWeight:
      pName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const useStyles = makeStyles((theme) => ({
  bgBlue: {
    height: "131vh",
    background:
      "-webkit-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
  },
  title: {
    flexGrow: 1,
    fontSize: "1.1rem",
    fontWeight: "450",
    paddingRight: "20px",
  },
  appbarBackground: {
    backgroundColor: "#fff",
    color: "#1d428a",
  },
  backButton: {
    backgroundColor: "white",
    minWidth: "50px",
    "&:hover": {
      backgroundColor: "white",
    },
    textTransform: "none",
    border: "1px solid lightgrey",
    boxShadow: "1px 1px 3px 1px lightgrey",
  },
  actionButtons: {
    padding: "0px 12px 0px 10px",
    height: "40px",
  },
  appbar: {
    backgroundColor: "#f5f5f5",
    color: "#000000",
    "& .Mui-selected": {
      color: theme.palette.primary.main,
    },
  },

  headerText: {
    marginBottom: theme.spacing(0.5),
    color: "#1d428a",
  },
  exportToExcel: {
    backgroundColor: "white",
    minWidth: "50px",
    "&:hover": {
      backgroundColor: "white",
    },
  },
  excelButton: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flex: "1",
    paddingRight: theme.spacing(1),
  },
}));

var positionCount = 0;
var collegeCount = 0;
var selectedplayer = [];
var playerCount = 0;
var selectedposition = [];
var selectedcollege = [];

//... Tab Essential entities
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const styleHeaderCss = {
  fill: {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "e6eefb" },
  },
  font: { sz: "11", bold: true, color: { rgb: "1d428a" } },
  border: {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  },
  alignment: {
    wrapText: true,
    horizontal: "center",
    vertical: "top",
  },
};

export default function GroupCombineResults({ setSelectedMiniTab }) {
  const classes = useStyles();

  const params = useParams();

  //... User Context.
  const {
    user,
    selectedEventId,
    getActiveEventId,
    selectedCombineResultsTab,
    isShowDEXABodyFat,
    lengthUnits,
    weightUnits,
    setWeightUnits,
    setLengthUnits,
    getWeightUnitValue,
    getLengthUnitValue,
    getLengthUnitLabelType,
    getWeightUnitLabelType,
    getHandDimensionsUnitValue,
    getHandDimensionsUnitLabelType,
    selectedEvent,
    combineYear,
    setSelectedEventId,
    setSelectedEvent,
    setCombineYear,
  } = useContext(AppDataContext);

  const [eventId, setEventId] = useState(selectedEventId);
  //const [eventId, setEventId] = useState(params.eventId);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);
  const [pName, setPName] = React.useState([]);
  const [cName, setCName] = React.useState([]);
  const [list, setList] = useState([]);
  const [listShootingDrill, setListShootingDrill] = useState([]);
  const [excelClick, setExcelClick] = useState(false);
  const [isWebView, setIsWebView] = useState(false);

  //... Anthros,Strength And Agility & Shooting Drill tabel column data.
  const playerAnthrosAndStrengthAgiltyColumns = [
    {
      id: "playerName",
      headerName: "Player Name",
    },
    {
      id: "position",
      headerName: "Position",
    },
    {
      id: "collegeOrClub",
      headerName: "College Name",
    },
    {
      id: "standingReach",
      headerName: "Standing Reach",
    },
    {
      id: "wingSpan",
      headerName: "Wingspan",
    },
    // {
    //   id: "heightWithShoes",
    //   headerName: "Height With Shoes",
    // },
    {
      id: "heightWithOutShoes",
      headerName: "Height W/o Shoes",
    },
    {
      id: "bodyWeight",
      headerName: "Weight",
    },
    {
      id: "handLength",
      headerName: "Hand Dimensions",
    },
    {
      id: "bodyFat",
      headerName: "Body Fat",
    },
    ...(isShowDEXABodyFat === "true"
      ? [
          {
            id: "bodyFatDXA",
            headerName: "DEXA Body Fat",
          },
        ]
      : []),
    {
      id: "shuttleRunLeftTrialTime",
      headerName: "Lane Shuttle Left",
    },
    {
      id: "shuttleRunRightTrialTime",
      headerName: "Lane Shuttle Right",
    },
    {
      id: "threeFourRunTime",
      headerName: "3/4 Court Sprint",
    },
    {
      id: "proLaneTrialTime",
      headerName: "Pro Lane",
    },
    {
      id: "maxVerticalLeap",
      headerName: "Max Vertical Jump",
    },
    {
      id: "standingVerticalLeap",
      headerName: "Standing Vertical",
    },
    {
      id: "hipAbductionPeakForce",
      headerName: "Hip Abduction",
    },
    {
      id: "hipAdductionPeakForce",
      headerName: "Hip Adduction",
    },
    {
      id: "kneeExtensionPeakForce",
      headerName: "Knee Extension",
    },
    {
      id: "kneeFlexionPeakForce",
      headerName: "Knee Flexion",
    },
    {
      id: "anklePlantarFlexionPeakForce",
      headerName: "Ankle Plantar Flexion",
    },
  ];

  const playerShootingDrillsColumns = [
    {
      id: "playerName",
      headerName: "Player Name",
    },
    // {
    //   id: "position",
    //   headerName: "Position",
    // },
    // {
    //   id: "collegeOrClub",
    //   headerName: "College Name",
    // },
    {
      id: "noOfMadeSpotup",
      headerName: "Spot Up",
    },
    {
      id: "noOfMadeSideMidSide",
      headerName: "Side Mid Side",
    },
    {
      id: "noOfMadeMidSideMid",
      headerName: "Mid Side Mid",
    },
    {
      id: "noOfMadeOffTheDribble",
      headerName: "Off The Dribble",
    },
    {
      id: "noOfMadeFreeThrows",
      headerName: "Free Throws",
    },
    {
      id: "noOfMade3PointStar",
      headerName: "3 Point Star",
    },
    {
      id: "noOfMadeMidRangeStar",
      headerName: "Mid Range Star",
    },
  ];

  const handleChange = (event1) => {
    const {
      target: { value },
    } = event1;
    if (selectedplayer.length === 0) {
      playerCount = playerCount + 1;
    } else if (selectedplayer.length <= value.length) {
      playerCount = playerCount + 1;
    } else if (selectedplayer.length > value.length) {
      playerCount = playerCount - 1;
    }

    selectedplayer = value;
    setPersonName(value);
    getplayer(value);
    setPlayerValue(value);
  };

  const handleChangeCollege = (event1) => {
    const {
      target: { value },
    } = event1;

    if (selectedcollege.length === 0) {
      collegeCount = collegeCount + 1;
    } else if (selectedcollege.length <= value.length) {
      collegeCount = collegeCount + 1;
    } else if (selectedcollege.length > value.length) {
      collegeCount = collegeCount - 1;
    }
    selectedcollege = value;

    setCName(value);
    getplayerCollege(value);
    setCollegeValue(value);
  };

  const handleChangePosition = (event1) => {
    const {
      target: { value },
    } = event1;

    if (selectedposition.length === 0) {
      positionCount = positionCount + 1;
    } else if (selectedposition.length <= value.length) {
      positionCount = positionCount + 1;
    } else if (selectedposition.length > value.length) {
      positionCount = positionCount - 1;
    }
    selectedposition = value;

    setPName(value);
    getplayerPosition(value);
    setPositionValue(selectedposition);
  };

  function getplayer(value) {
    setFavPlayersAnthrosDataSelected([]);
    setFavPlayersSAAgilityDataSelected([]);
    setfavPlayersShootingDrillDataselected([]);

    if (value.length > 0) {
      // CASE 1: ANTHROS
      var playerAnthros;
      var playerAnthrosList = [];
      var playerAnthrosPos;
      var anthrowsPosList = [];
      var playerAnthrosCol;
      var anthrosColList = [];

      // CASE 2: STRENGTH AND AGILITY
      var playerSAAgility;
      var playerSAAgilityList = [];
      var playerSAAgilityPos;
      var sAAgilityPosList = [];
      var playersAAgilityCol;
      var sAAgilityColList = [];

      // CASE 3: SHOOTING DRILLS
      var playerDrillList = [];
      var playerDrillListpos = [];
      var playerDrillListcol = [];
      var playerDrill;
      var playerDrillpos;
      var playerDrillcol;

      for (let i = 0; i < value.length; ++i) {
        // CASE 1: ANTHROS
        playerAnthros = favPlayersAnthrosData.filter((val, index) => {
          return (
            val.playerName.replace(/ /g, "") === value[i].replace(/ /g, "")
          );
        });
        playerAnthrosList = [...playerAnthrosList, ...playerAnthros];

        // CASE 2: STRENGTH AND AGILITY
        playerSAAgility = favPlayersSAAgilityData.filter((val, index) => {
          return (
            val.playerName.replace(/ /g, "") === value[i].replace(/ /g, "")
          );
        });
        playerSAAgilityList = [...playerSAAgilityList, ...playerSAAgility];

        // CASE 3: SHOOTING DRILLS
        playerDrill = favPlayersShootingDrillData.filter((val, index) => {
          return (
            val.playerName.replace(/ /g, "") === value[i].replace(/ /g, "")
          );
        });
        playerDrillList = [...playerDrillList, ...playerDrill];
      }

      if (selectedposition.length > 0) {
        for (var j = 0; j < selectedposition.length; ++j) {
          // CASE 1: ANTHROS
          playerAnthrosPos = playerAnthrosList.filter((val, index) => {
            return val.position === selectedposition[j];
          });
          anthrowsPosList = [...anthrowsPosList, ...playerAnthrosPos];

          // CASE 2: STRENGTH AND AGILITY
          playerSAAgilityPos = playerSAAgilityList.filter((val, index) => {
            return val.position === selectedposition[j];
          });
          sAAgilityPosList = [...sAAgilityPosList, ...playerSAAgilityPos];

          // CASE 3: SHOOTING DRILLS
          playerDrillpos = playerDrillList.filter((val, index) => {
            return val.position === selectedposition[j];
          });
          playerDrillListpos = [...playerDrillListpos, ...playerDrillpos];
        }
      } else {
        anthrowsPosList = playerAnthrosList;
        sAAgilityPosList = playerSAAgilityList;
        playerDrillListpos = playerDrillList;
      }

      if (selectedcollege.length > 0) {
        for (var k = 0; k < selectedcollege.length; ++k) {
          // CASE 1: ANTHROS
          playerAnthrosCol = anthrowsPosList.filter((val, index) => {
            return val.collegeOrClub === selectedcollege[k];
          });
          anthrosColList = [...anthrosColList, ...playerAnthrosCol];

          // CASE 2: STRENGTH AND AGILITY
          playersAAgilityCol = sAAgilityPosList.filter((val, index) => {
            return val.collegeOrClub === selectedcollege[k];
          });
          sAAgilityColList = [...sAAgilityColList, ...playersAAgilityCol];

          // CASE 3: SHOOTING DRILLS
          playerDrillcol = playerDrillListpos.filter((val, index) => {
            return val.collegeOrClub === selectedcollege[k];
          });
          playerDrillListcol = [...playerDrillListcol, ...playerDrillcol];
        }
      } else {
        anthrosColList = anthrowsPosList;
        sAAgilityColList = sAAgilityPosList;
        playerDrillListcol = playerDrillListpos;
      }

      // CASE 1: ANTHROS
      var anThrowsFilterdata = [...anthrosColList];
      var newAnThrowsFilterdata = anThrowsFilterdata.filter(
        (elem, pos) => anThrowsFilterdata.indexOf(elem) === pos
      );
      // CASE 2: STRENGTH AND AGILITY
      var sAAgilityFilterdata = [...sAAgilityColList];
      var newSAgilityFilterdata = sAAgilityFilterdata.filter(
        (elem, pos) => sAAgilityFilterdata.indexOf(elem) === pos
      );
      // CASE 3: SHOOTING DRILLS
      var drillfilterdata = [...playerDrillListcol];
      var newdrillfilterdata = drillfilterdata.filter(function (elem, pos) {
        return drillfilterdata.indexOf(elem) === pos;
      });

      playerSelected = true;
      setFavPlayersAnthrosDataSelected(newAnThrowsFilterdata);
      setListAnthros(newAnThrowsFilterdata);

      setFavPlayersSAAgilityDataSelected(newSAgilityFilterdata);
      setListSAAgelity(newSAgilityFilterdata);

      setfavPlayersShootingDrillDataselected(newdrillfilterdata);
      setListShootingDrill(newdrillfilterdata);
      setShowval(true);
    } else {
      setShowval(false);
      setListAnthros(favPlayersAnthrosData);
      setListSAAgelity(favPlayersSAAgilityData);
      setListShootingDrill(favPlayersShootingDrillData);
      playerSelected = false;
    }
  }

  function getplayersAfterdelete(value) {
    if (value !== "") {
      // CASE 1: ANTHROS
      var playerAnthros;
      var playerAnthrosList = [];

      // CASE 2: STRENGTH AND AGILITY
      var playerSAAgility;
      var playerSAAgilityList = [];

      // CASE 3: SHOOTING DRILLS
      var playerDrillList = [];
      var playerDrill;

      //COMMON
      playerSelected = true;

      // CASE 1 -ANTHROWS
      playerAnthros = favPlayersAnthrosDataSelected.filter((val, index) => {
        return val.playerName !== value;
      });
      playerAnthrosList = [...playerAnthrosList, ...playerAnthros];

      // CASE 2 -SAS
      playerSAAgility = favPlayersSAAgilityDataSelected.filter((val, index) => {
        return val.playerName !== value;
      });
      playerSAAgilityList = [...playerSAAgilityList, ...playerSAAgility];

      // CASE 3 -Shooting
      playerDrill = favPlayersShootingDrillDataselected.filter((val, index) => {
        return val.playerName !== value;
      });
      playerDrillList = [...playerDrillList, ...playerDrill];

      setFavPlayersAnthrosDataSelected(playerAnthrosList);
      setListAnthros(playerAnthrosList);
      setFavPlayersSAAgilityDataSelected(playerSAAgilityList);
      setListSAAgelity(playerSAAgilityList);
      setfavPlayersShootingDrillDataselected(playerDrillList);
      setListShootingDrill(playerDrillList);

      if (playerCount === 0) {
        setShowval(false);
        setListAnthros(favPlayersAnthrosData);
        setListSAAgelity(favPlayersSAAgilityData);
        setListShootingDrill(favPlayersShootingDrillData);

        if (collegeValue !== "" && collegeCount !== 0) {
          getplayerCollege(collegeValue);
          if (positionValue !== "" && positionCount !== 0) {
            getplayerPosition(positionValue);
          }
        } else if (positionValue !== "" && positionCount !== 0) {
          getplayerPosition(pName);
          if (collegeValue !== "" && collegeCount !== 0) {
            getplayerCollege(collegeValue);
          }
        }
      } else {
        if (
          // pName.length === 1 ||
          // cName.length === 1 ||
          personName.length === 1 &&
          pName.length < 1 &&
          cName.length < 1
        ) {
          setShowval(false);
        } else setShowval(true);
      }
    } else {
      if (positionSelected === false) {
        setShowval(false);
        setListAnthros(favPlayersAnthrosData);
        setListSAAgelity(favPlayersSAAgilityData);
        setListShootingDrill(favPlayersShootingDrillData);
      }
      playerSelected = false;
    }
  }

  function getpositionAfterdelete(value) {
    if (value !== "") {
      // CASE 1: ANTHROS
      var playerAnthros;
      var playerAnthrosList = [];

      // CASE 2: STRENGTH AND AGILITY
      var playerSAAgility;
      var playerSAAgilityList = [];

      // CASE 3: SHOOTING DRILLS
      var playerDrillList = [];
      var playerDrill;

      // CASE 1: ANTHROS
      playerAnthros = favPlayersAnthrosDataSelected.filter((val, index) => {
        return val.position !== value;
      });
      playerAnthrosList = [...playerAnthrosList, ...playerAnthros];

      // CASE 2: STRENGTH AND AGILITY
      playerSAAgility = favPlayersSAAgilityDataSelected.filter((val, index) => {
        return val.position !== value;
      });
      playerSAAgilityList = [...playerSAAgilityList, ...playerSAAgility];

      // CASE 3: SHOOTING DRILLS
      playerDrill = favPlayersShootingDrillDataselected.filter((val, index) => {
        return val.position !== value;
      });
      playerDrillList = [...playerDrillList, ...playerDrill];

      positionSelected = true;
      setFavPlayersAnthrosDataSelected(playerAnthrosList);
      setListAnthros(playerAnthrosList);
      setFavPlayersSAAgilityDataSelected(playerSAAgilityList);
      setListSAAgelity(playerSAAgilityList);
      setfavPlayersShootingDrillDataselected(playerDrillList);
      setListShootingDrill(playerDrillList);

      if (positionCount === 0) {
        setShowval(false);
        setListAnthros(favPlayersAnthrosData);
        setListSAAgelity(favPlayersSAAgilityData);
        setListShootingDrill(favPlayersShootingDrillData);

        if (playerValue !== "" && playerCount !== 0) {
          getplayer(playerValue);
          if (collegeValue !== "" && collegeCount !== 0) {
            getplayerCollege(collegeValue);
          }
        } else if (collegeValue !== "" && collegeCount !== 0) {
          getplayerCollege(collegeValue);
          setListShootingDrill(favPlayersShootingDrillData);
          if (playerValue !== "" && playerCount !== 0) {
            getplayer(playerValue);
          }
        }
      } else {
        if (
          pName.length === 1 &&
          personName.length < 1 &&
          cName.length < 1

          // ||
          // cName.length === 1 ||
          // personName.length === 1
        ) {
          setShowval(false);
        } else setShowval(true);
      }
    } else {
      setShowval(false);
      setListAnthros(favPlayersAnthrosData);
      setListSAAgelity(favPlayersSAAgilityData);
      setListShootingDrill(favPlayersShootingDrillData);

      positionSelected = false;
    }
  }

  function getcollegeAfterdelete(value) {
    if (value !== "") {
      // CASE 1: ANTHROS
      var playerAnthros;
      var playerAnthrosList = [];
      playerAnthros = favPlayersAnthrosDataSelected.filter((val, index) => {
        return val.collegeOrClub !== value;
      });
      playerAnthrosList = [...playerAnthrosList, ...playerAnthros];

      // CASE 2: STRENGTH AND AGILITY
      var playerSAAgility;
      var playerSAAgilityList = [];
      playerSAAgility = favPlayersSAAgilityDataSelected.filter((val, index) => {
        return val.collegeOrClub !== value;
      });
      playerSAAgilityList = [...playerSAAgilityList, ...playerSAAgility];

      // CASE 3: SHOOTING DRILLS
      var playerDrillList = [];
      var playerDrill;
      playerDrill = favPlayersShootingDrillDataselected.filter((val, index) => {
        return val.collegeOrClub !== value;
      });
      playerDrillList = [...playerDrillList, ...playerDrill];

      collegeSelected = true;
      setFavPlayersAnthrosDataSelected(playerAnthrosList);
      setListAnthros(playerAnthrosList);
      setFavPlayersSAAgilityDataSelected(playerSAAgilityList);
      setListSAAgelity(playerSAAgilityList);
      setfavPlayersShootingDrillDataselected(playerDrillList);
      setListShootingDrill(playerDrillList);

      if (collegeCount === 0) {
        setShowval(false);
        setListAnthros(favPlayersAnthrosData);
        setListSAAgelity(favPlayersSAAgilityData);
        setListShootingDrill(favPlayersShootingDrillData);

        if (playerValue !== "" && playerCount !== 0) {
          getplayer(playerValue);
          if (positionValue !== "" && positionCount !== 0) {
            getplayerPosition(positionValue);
          }
        } else if (positionValue !== "" && positionCount !== 0) {
          getplayerPosition(positionValue);
          if (playerValue !== "" && playerCount !== 0) {
            getplayer(playerValue);
          }
        }
      } else {
        if (
          // pName.length === 1 ||
          cName.length === 1 &&
          personName.length < 1 &&
          pName.length < 1
          // ||
          // personName.length === 1
        ) {
          setShowval(false);
        } else setShowval(true);
      }
    } else {
      setShowval(false);
      setListAnthros(favPlayersAnthrosData);
      setListSAAgelity(favPlayersSAAgilityData);
      setListShootingDrill(favPlayersShootingDrillData);

      collegeSelected = false;
    }
  }

  function getplayerPosition(value) {
    setFavPlayersAnthrosDataSelected([]);
    setFavPlayersSAAgilityDataSelected([]);
    setfavPlayersShootingDrillDataselected([]);

    if (value.length > 0) {
      // CASE 1: ANTHROS
      var playerAnthros;
      var playerAnthrosList = [];
      var playerAnthrosPos;
      var anthrowsPosList = [];
      var playerAnthrosCol;
      var anthrosColList = [];

      // CASE 2: STRENGTH AND AGILITY
      var playerSAAgility;
      var playerSAAgilityList = [];
      var playerSAAgilityPos;
      var sAAgilityPosList = [];
      var playersAAgilityCol;
      var sAAgilityColList = [];

      // CASE 3: SHOOTING DRILLS
      var playerDrillList = [];
      var playerDrillListpos = [];
      var playerDrillListcol = [];
      var playerDrill;
      var playerDrillpos;
      var playerDrillcol;

      for (var i = 0; i < value.length; ++i) {
        // CASE 1: ANTHROS
        playerAnthrosPos = favPlayersAnthrosData.filter((val, index) => {
          return val.position === value[i];
        });
        anthrowsPosList = [...anthrowsPosList, ...playerAnthrosPos];

        // CASE 2: STRENGTH AND AGILITY
        playerSAAgilityPos = favPlayersSAAgilityData.filter((val, index) => {
          return val.position === value[i];
        });
        sAAgilityPosList = [...sAAgilityPosList, ...playerSAAgilityPos];

        // CASE 3: SHOOTING DRILLS
        playerDrillpos = favPlayersShootingDrillData.filter((val, index) => {
          return val.position === value[i];
        });
        playerDrillListpos = [...playerDrillListpos, ...playerDrillpos];
      }

      if (selectedplayer.length > 0) {
        for (var j = 0; j < selectedplayer.length; ++j) {
          // CASE 1: ANTHROS
          playerAnthros = anthrowsPosList.filter((val, index) => {
            return val.playerName === selectedplayer[j];
          });
          playerAnthrosList = [...playerAnthrosList, ...playerAnthros];

          // CASE 2: STRENGTH AND AGILITY
          playerSAAgility = sAAgilityPosList.filter((val, index) => {
            return val.playerName === selectedplayer[j];
          });
          playerSAAgilityList = [...playerSAAgilityList, ...playerSAAgility];

          // CASE 3: SHOOTING DRILLS
          playerDrill = playerDrillListpos.filter((val, index) => {
            return val.playerName === selectedplayer[j];
          });
          playerDrillList = [...playerDrillList, ...playerDrill];
        }
      } else {
        playerAnthrosList = anthrowsPosList;
        playerSAAgilityList = sAAgilityPosList;
        playerDrillList = playerDrillListpos;
      }

      if (selectedcollege.length > 0) {
        for (var k = 0; k < selectedcollege.length; ++k) {
          // CASE 1: ANTHROS
          playerAnthrosCol = playerAnthrosList.filter((val, index) => {
            return val.collegeOrClub === selectedcollege[k];
          });
          anthrosColList = [...anthrosColList, ...playerAnthrosCol];

          // CASE 2: STRENGTH AND AGILITY
          playersAAgilityCol = playerSAAgilityList.filter((val, index) => {
            return val.collegeOrClub === selectedcollege[k];
          });
          sAAgilityColList = [...sAAgilityColList, ...playersAAgilityCol];

          // CASE 3: SHOOTING DRILLS
          playerDrillcol = playerDrillList.filter((val, index) => {
            return val.collegeOrClub === selectedcollege[k];
          });
          playerDrillListcol = [...playerDrillListcol, ...playerDrillcol];
        }
      } else {
        anthrosColList = playerAnthrosList;
        sAAgilityColList = playerSAAgilityList;
        playerDrillListcol = playerDrillList;
      }

      // CASE 1: ANTHROS
      var anThrowsFilterdata = [...anthrosColList];
      var newAnThrowsFilterdata = anThrowsFilterdata.filter(
        (elem, pos) => anThrowsFilterdata.indexOf(elem) === pos
      );
      // CASE 2: STRENGTH AND AGILITY
      var sAAgilityFilterdata = [...sAAgilityColList];
      var newSAgilityFilterdata = sAAgilityFilterdata.filter(
        (elem, pos) => sAAgilityFilterdata.indexOf(elem) === pos
      );
      // CASE 3: SHOOTING DRILLS
      var drillfilterdata = [...playerDrillListcol];
      var newdrillfilterdata = drillfilterdata.filter(function (elem, pos) {
        return drillfilterdata.indexOf(elem) === pos;
      });

      positionSelected = true;
      setFavPlayersAnthrosDataSelected(newAnThrowsFilterdata);
      setListAnthros(newAnThrowsFilterdata);
      setFavPlayersSAAgilityDataSelected(newSAgilityFilterdata);
      setListSAAgelity(newSAgilityFilterdata);
      setfavPlayersShootingDrillDataselected(newdrillfilterdata);
      setListShootingDrill(newdrillfilterdata);
      setShowval(true);
    } else {
      setShowval(false);
      // getplayer1(playerValue);
      setListAnthros(favPlayersAnthrosData);
      setListSAAgelity(favPlayersSAAgilityData);
      setListShootingDrill(favPlayersShootingDrillData);

      positionSelected = false;
    }
  }

  function getplayerCollege(value) {
    setFavPlayersAnthrosDataSelected([]);
    setFavPlayersSAAgilityDataSelected([]);
    setfavPlayersShootingDrillDataselected([]);

    if (value.length > 0) {
      // CASE 1: ANTHROS
      var playerAnthros;
      var playerAnthrosList = [];
      var playerAnthrosPos;
      var anthrowsPosList = [];
      var playerAnthrosCol;
      var anthrosColList = [];

      // CASE 2: STRENGTH AND AGILITY
      var playerSAAgility;
      var playerSAAgilityList = [];
      var playerSAAgilityPos;
      var sAAgilityPosList = [];
      var playersAAgilityCol;
      var sAAgilityColList = [];

      // CASE 3: SHOOTING DRILLS
      var playerDrillList = [];
      var playerDrillListpos = [];
      var playerDrillListcol = [];
      var playerDrill;
      var playerDrillpos;
      var playerDrillcol;

      for (var i = 0; i < value.length; ++i) {
        // CASE 1: ANTHROS
        playerAnthrosCol = favPlayersAnthrosData.filter((val, index) => {
          return val.collegeOrClub === value[i];
        });
        anthrosColList = [...anthrosColList, ...playerAnthrosCol];

        // CASE 2: STRENGTH AND AGILITY
        playersAAgilityCol = favPlayersSAAgilityData.filter((val, index) => {
          return val.collegeOrClub === value[i];
        });
        sAAgilityColList = [...sAAgilityColList, ...playersAAgilityCol];

        // CASE 3: SHOOTING DRILLS
        playerDrillcol = favPlayersShootingDrillData.filter((val, index) => {
          return val.collegeOrClub === value[i];
        });
        playerDrillListcol = [...playerDrillListcol, ...playerDrillcol];
      }

      if (selectedplayer.length > 0) {
        for (var j = 0; j < selectedplayer.length; ++j) {
          // CASE 1: ANTHROS
          playerAnthros = anthrosColList.filter((val, index) => {
            return val.playerName === selectedplayer[j];
          });
          playerAnthrosList = [...playerAnthrosList, ...playerAnthros];

          // CASE 2: STRENGTH AND AGILITY
          playerSAAgility = sAAgilityColList.filter((val, index) => {
            return val.playerName === selectedplayer[j];
          });
          playerSAAgilityList = [...playerSAAgilityList, ...playerSAAgility];

          // CASE 3: SHOOTING DRILLS
          playerDrill = playerDrillListcol.filter((val, index) => {
            return val.playerName === selectedplayer[j];
          });
          playerDrillList = [...playerDrillList, ...playerDrill];
        }
      } else {
        playerAnthrosList = anthrosColList;
        playerSAAgilityList = sAAgilityColList;
        playerDrillList = playerDrillListcol;
      }

      if (selectedposition.length > 0) {
        for (var k = 0; k < selectedposition.length; ++k) {
          // CASE 1: ANTHROS
          playerAnthrosPos = playerAnthrosList.filter((val, index) => {
            return val.position === selectedposition[k];
          });
          anthrowsPosList = [...anthrowsPosList, ...playerAnthrosPos];

          // CASE 2: STRENGTH AND AGILITY
          playerSAAgilityPos = playerSAAgilityList.filter((val, index) => {
            return val.position === selectedposition[k];
          });
          sAAgilityPosList = [...sAAgilityPosList, ...playerSAAgilityPos];

          // CASE 3: SHOOTING DRILLS
          playerDrillpos = playerDrillList.filter((val, index) => {
            return val.position === selectedposition[k];
          });
          playerDrillListpos = [...playerDrillListpos, ...playerDrillpos];
        }
      } else {
        anthrowsPosList = playerAnthrosList;
        sAAgilityPosList = playerSAAgilityList;
        playerDrillListpos = playerDrillList;
      }

      // CASE 1: ANTHROS
      var anThrowsFilterdata = [...anthrowsPosList];
      var newAnThrowsFilterdata = anThrowsFilterdata.filter(
        (elem, pos) => anThrowsFilterdata.indexOf(elem) === pos
      );
      // CASE 2: STRENGTH AND AGILITY
      var sAAgilityFilterdata = [...sAAgilityPosList];
      var newSAgilityFilterdata = sAAgilityFilterdata.filter(
        (elem, pos) => sAAgilityFilterdata.indexOf(elem) === pos
      );
      // CASE 3: SHOOTING DRILLS
      var drillfilterdata = [...playerDrillListpos];
      var newdrillfilterdata = drillfilterdata.filter(function (elem, pos) {
        return drillfilterdata.indexOf(elem) === pos;
      });

      collegeSelected = true;
      setFavPlayersAnthrosDataSelected(newAnThrowsFilterdata);
      setListAnthros(newAnThrowsFilterdata);
      setFavPlayersSAAgilityDataSelected(newSAgilityFilterdata);
      setListSAAgelity(newSAgilityFilterdata);
      setfavPlayersShootingDrillDataselected(newdrillfilterdata);
      setListShootingDrill(newdrillfilterdata);
      setShowval(true);
    } else {
      setShowval(false);
      // getplayer1(playerValue);
      setListAnthros(favPlayersAnthrosData);
      setListSAAgelity(favPlayersSAAgilityData);
      setListShootingDrill(favPlayersShootingDrillData);

      collegeSelected = false;
    }
  }

  const [strengthAgilityFlag, setStrengthAgilityFlag] = useState([]);
  const [selectedTab, setSelectedTab] = useState(selectedCombineResultsTab);
  const [laneShuttleLeft, setLaneShuttleLeft] = useState({
    active: false,
    data: [],
  });
  const [laneShuttleRight, setLaneShuttleRight] = useState({
    active: false,
    data: [],
  });
  const [threeFour, setThreeFour] = useState({ active: false, data: [] });
  const [proLane, setPROLane] = useState({ active: false, data: [] });
  const [maxVerticalJump, setMaxVerticalJump] = useState({
    active: false,
    data: [],
  });
  const [standingVerticalJump, setStandingVerticalJump] = useState({
    active: false,
    data: [],
  });

  /// Anthros LeaderBoard
  const [bodyFat, setBodyFat] = useState({ active: false, data: [] });
  const [dXABodyFat, setDXABodyFat] = useState({ active: false, data: [] });
  const [handDimentions, setHandDimentions] = useState({
    active: false,
    data: [],
  });
  const [weight, setWeight] = useState({ active: false, data: [] });
  const [heightWithShoes, setHeightWithShoes] = useState({
    active: false,
    data: [],
  });
  const [heightWithoutShoes, setHeightWithoutShoes] = useState({
    active: false,
    data: [],
  });
  const [standingReach, setStandingReach] = useState({
    active: false,
    data: [],
  });
  const [wingSpanDimentions, setWingSpanDimentions] = useState({
    active: false,
    data: [],
  });
  const [spotUp, setSpotUp] = useState({
    active: false,
    data: [],
  });
  const [sideMidSide, setSideMidSide] = useState({
    active: false,
    data: [],
  });
  const [midSideMid, setMidSideMid] = useState({
    active: false,
    data: [],
  });
  const [offTheDribble, setOffTheDribble] = useState({
    active: false,
    data: [],
  });
  const [freeThrows, setFreeThrows] = useState({
    active: false,
    data: [],
  });
  const [point3Star, setPoint3Star] = useState({
    active: false,
    data: [],
  });
  const [midRangeStar, setMidRangeStar] = useState({
    active: false,
    data: [],
  });
  const [notes, setNotes] = useState([]);
  const [playerName, setplayerName] = useState([]);
  const [collegeName, setcollegeName] = useState([]);
  const [positionName, setPositionName] = useState([]);
  const [playerValue, setPlayerValue] = useState([]);
  const [positionValue, setPositionValue] = useState([]);
  const [collegeValue, setCollegeValue] = useState([]);
  const [Showval, setShowval] = useState(false);

  //... GROUP COMBINE RESULT TABLE VIEW DATA HOLDERS.
  const [favPlayersAnthrosData, setFavPlayersAnthrosData] = useState([]);
  const [favPlayersAnthrosDataSelected, setFavPlayersAnthrosDataSelected] =
    useState([]);
  const [listAnthros, setListAnthros] = useState([]);

  const [favPlayersSAAgilityData, setFavPlayersSAAgilityData] = useState([]);
  const [favPlayersSAAgilityDataSelected, setFavPlayersSAAgilityDataSelected] =
    useState([]);
  const [listSAAgelity, setListSAAgelity] = useState([]);

  const [favPlayersShootingDrillData, setfavPlayersShootingDrillData] =
    useState([]);
  const [
    favPlayersShootingDrillDataselected,
    setfavPlayersShootingDrillDataselected,
  ] = useState([]);

  //... Laser-time
  const [laserTimeData, setLaserTimeData] = useState({
    shuttleRunLaserTime: [],
    proLaneLaserTime: [],
    threeFourRunLaserTime: [],
  });

  //... UseEffects.
  useEffect(() => {
    if (isShowUnitDrawer) {
      setLengthUnits(4);
      setWeightUnits(1);
    }
  }, []);

  useEffect(() => {
    if (!user || Object.keys(user).length === 0) {
      return;
    }

    const webviewDetected = Helper.detectWebView();
    setIsWebView(webviewDetected);

    if (webviewDetected) {
      const eventId = sessionStorage.getItem("eventId");

      if (eventId) {
        const [combineYear, selectedEvent] = [
          eventId.slice(0, 4),
          eventId.slice(4),
        ];

        // alert(
        //   `✅ Running inside React Native WebView. Event ID: ${eventId} | ${combineYear} | ${selectedEvent}`
        // );

        setCombineYear(combineYear);
        setSelectedEvent(selectedEvent);
        setSelectedEventId(eventId);
      }
    }
  }, [user]);

  useEffect(() => {
    setFavPlayersAnthrosData([]);
    setFavPlayersAnthrosDataSelected([]);
    setFavPlayersSAAgilityData([]);
    setFavPlayersSAAgilityDataSelected([]);
    setfavPlayersShootingDrillData([]);
    setfavPlayersShootingDrillDataselected([]);
    setplayerName([]);
    setcollegeName([]);
    setPositionName([]);
    setPlayerValue([]);
    setPositionValue([]);
    setCollegeValue([]);
    setPersonName([]);
    setPName([]);
    setCName([]);
    setShowval(false);
    positionCount = 0;
    collegeCount = 0;
    selectedplayer = [];
    playerCount = 0;
    selectedposition = [];
    selectedcollege = [];

    setEventId(selectedEventId);
    setShowval(false);
    getplayer("");
    getplayerPosition("");
    getplayerCollege("");
  }, [selectedEventId]);

  useEffect(() => {
    if (eventId !== 0 && user && user.loginID && user?.userName) {
      setLoading(true);
      setPersonName([]);
      setPName([]);
      setCName([]);

      GetLeaderBoardFlags();
      GetLeaderBoardNotes();
      GetAllPlayers();
      GetAllPositions();

      //GetLeaderboardAnthroSAAgilityByEventID();
      GetStrengthAndAgilityLeaserTime();
      GetLeaderboardAnthrosDataByEventID();
      GetLeaderboardStrengthAndAgilityByEventID();
      GetgetShootingDrillLeaderBoardByEventID();
    } else {
      setLoading(true);
      // getActiveEventId();
    }
  }, [user, eventId]);

  useEffect(() => {
    if (excelClick) {
      document.getElementById("combineresult-list-excel-export").click();
      setExcelClick(false);
    }
  }, [excelClick]);

  useEffect(() => {
    GetStrengthAndAgilityData();
    GetAnthrosLeaderBoardData();
    GetShootingDrillsData();
  }, [strengthAgilityFlag]);

  const GetStrengthAndAgilityLeaserTime = async () => {
    const [
      shuttleRunTrialLaserTime,
      proLaneTrialLaserTime,
      threeFourTrialLaserTime,
    ] = await Promise.all([
      LeaderDashboardService.getShuttleRunTrialLaserTimeByEventID(eventId),
      LeaderDashboardService.getProLaneTrialLaserTimeByEventID(eventId),
      LeaderDashboardService.getThreeFourTrialLaserTimeByEventID(eventId),
    ]);

    setLaserTimeData({
      shuttleRunLaserTime: shuttleRunTrialLaserTime.data,
      proLaneLaserTime: proLaneTrialLaserTime.data,
      threeFourRunLaserTime: threeFourTrialLaserTime.data,
    });
  };

  //... Combine Result
  const GetgetShootingDrillLeaderBoardByEventID = async () => {
    let data =
      await LeaderDashboardService.getShootingDrillLeaderBoardByEventID(
        eventId,
        user?.loginID
      );

    setfavPlayersShootingDrillData(data.data);
    setListShootingDrill(data.data);
  };

  const GetLeaderboardAnthrosDataByEventID = async () => {
    let data = await LeaderDashboardService.getLeaderboardAnthrosDataByEventID(
      eventId,
      user?.userName
    );

    setFavPlayersAnthrosData(data.data);
    setListAnthros(data.data);
  };

  const GetLeaderboardStrengthAndAgilityByEventID = async () => {
    let data =
      await LeaderDashboardService.getLeaderboardStrengthAndAgilityByEventID(
        eventId,
        user?.loginID
      );

    setFavPlayersSAAgilityData(data.data);
    setListSAAgelity(data.data);
  };

  const GetAllPlayers = async () => {
    PlayerProfileService.getPlayerListByEventIdYear(eventId, user?.loginID)
      .then((result) => {
        var playerName = [];
        var collegename = [];
        var newcollegename = [];
        var sortedcollegeName = [];

        for (var i = 0; i < result.data.length; ++i) {
          playerName = [...playerName, result.data[i].playerName];
          collegename = [...collegename, result.data[i].collegeOrClub];
        }

        newcollegename = collegename.filter(function (elem, pos) {
          return collegename.indexOf(elem) === pos;
        });

        var sortedcollegeName = newcollegename.sort(function (a, b) {
          return a.localeCompare(b); //using String.prototype.localCompare()
        });

        setplayerName(playerName);
        setcollegeName(sortedcollegeName);
        return result;
      })
      .catch(handleError);
  };

  const GetAllPositions = async () => {
    PlayerProfileService.getPlayerPositions()
      .then((result) => {
        var playingPosition = [];
        for (var i = 0; i < result.data.length; ++i) {
          //   if (result.data[i].childName === "C" || result.data[i].childName === "G"|| result.data[i].childName === "F")
          playingPosition = [...playingPosition, result.data[i].childName];
        }
        var sortedpos = playingPosition.sort(function (a, b) {
          return a.localeCompare(b); //using String.prototype.localCompare()
        });
        setPositionName(sortedpos);

        return result;
      })
      .catch(handleError);
  };

  const GetLeaderBoardFlags = async () => {
    let flags = await LeaderDashboardService.getStrengthAndAgilityFlag();
    setStrengthAgilityFlag(flags.data);
  };

  const GetLeaderBoardNotes = async () => {
    let data = await LeaderDashboardService.getLeaderBoardNotes();
    //setNotes(data.data);

    //Filter the notes based on event.
    const filteredData = data.data.filter(
      (notes) => notes.childID === parseInt(selectedEventId)
    );

    //Make all unique notes and set to respective state.
    setNotes([...new Map(filteredData.map((m) => [m.childName, m])).values()]);
  };

  const GetStrengthAndAgilityData = () => {
    if (strengthAgilityFlag && strengthAgilityFlag.length > 0) {
      strengthAgilityFlag.forEach((flag) => {
        if (
          flag.childID < 7 &&
          strengthAndAgilityStations.includes(flag.childName)
        ) {
          setLoading(true);
          if (flag.childID == 1 && flag.childName == 201) {
            GetStrengthAndAgilityDataByStationId(
              eventId,
              flag.childName,
              0,
              2010,
              flag.isActive,
              user?.loginID
            );
          } else if (flag.childID == 2 && flag.childName == 201) {
            GetStrengthAndAgilityDataByStationId(
              eventId,
              flag.childName,
              1,
              2011,
              flag.isActive,
              user?.loginID
            );
          } else {
            GetStrengthAndAgilityDataByStationId(
              eventId,
              flag.childName,
              0,
              flag.childName,
              flag.isActive,
              user?.loginID
            );
          }
        }
      });
    }
  };

  const GetAnthrosLeaderBoardData = () => {
    if (strengthAgilityFlag && strengthAgilityFlag.length > 0) {
      strengthAgilityFlag.forEach((flag) => {
        if (flag.childID > 6 && anthrosStations.includes(flag.childName)) {
          GetAnthrosLeaderBoardByStationId(
            eventId,
            flag.childName,
            flag.isActive,
            user?.loginID
          );
        }
      });
    }
  };

  const GetShootingDrillsData = () => {
    if (strengthAgilityFlag && strengthAgilityFlag.length > 0) {
      strengthAgilityFlag.forEach((flag) => {
        if (flag.childID > 13 && shootingStations.includes(flag.childName)) {
          GetShootingDrillsByStationId(
            eventId,
            flag.childName,
            flag.isActive,
            user?.loginID
          );
        }
      });
    }
  };

  const GetAnthrosLeaderBoardByStationId = async (
    eventId,
    stationId,
    isActive,
    userBy
  ) => {
    setLoading(true);
    let data = await LeaderDashboardService.getAnthrosLeaderBoardByStationId(
      eventId,
      stationId,
      userBy
    );
    setLoading(false);
    switch (stationId) {
      case (stationId = "101"):
        setBodyFat({ active: isActive, data: data.data });
        return;
      case (stationId = "102"):
        setHandDimentions({ active: isActive, data: data.data });
        return;
      case (stationId = "103"):
        setWeight({ active: isActive, data: data.data });
        return;
      case (stationId = "104"):
        setHeightWithShoes({ active: isActive, data: data.data });
        return;
      case (stationId = "105"):
        setHeightWithoutShoes({ active: isActive, data: data.data });
        return;
      case (stationId = "106"):
        setStandingReach({ active: isActive, data: data.data });
        return;
      case (stationId = "107"):
        setWingSpanDimentions({ active: isActive, data: data.data });
        return;
      case (stationId = "108"):
        setDXABodyFat({ active: isActive, data: data.data });
        return;
      default:
        return;
    }
  };

  const GetStrengthAndAgilityDataByStationId = async (
    eventId,
    stationId,
    state,
    value,
    isActive,
    userBy
  ) => {
    setLoading(true);
    let data =
      await LeaderDashboardService.getStrengthAndAgilityDataByStationId(
        eventId,
        stationId,
        state,
        userBy
      );
    setLoading(false);
    switch (value) {
      case (value = 2010):
        setLaneShuttleLeft({ active: isActive, data: data.data });
        return;
      case (value = 2011):
        setLaneShuttleRight({ active: isActive, data: data.data });
        return;
      case (value = "202"):
        setThreeFour({ active: isActive, data: data.data });
        return;
      case (value = "203"):
        setPROLane({ active: isActive, data: data.data });
        return;
      case (value = "204"):
        setMaxVerticalJump({ active: isActive, data: data.data });
        return;
      case (value = "205"):
        setStandingVerticalJump({ active: isActive, data: data.data });
        return;
      default:
        return;
    }
  };

  const GetShootingDrillsByStationId = async (
    eventId,
    stationId,
    isActive,
    userBy
  ) => {
    setLoading(true);
    let data = await LeaderDashboardService.getShootingDrillsByStationId(
      eventId,
      stationId,
      userBy
    );
    setLoading(false);
    switch (stationId) {
      case (stationId = "301"):
        setSpotUp({ active: isActive, data: data.data });
        return;
      case (stationId = "302"):
        setSideMidSide({ active: isActive, data: data.data });
        return;
      case (stationId = "303"):
        setOffTheDribble({ active: isActive, data: data.data });
        return;
      case (stationId = "304"):
        setFreeThrows({ active: isActive, data: data.data });
        return;
      case (stationId = "305"):
        setPoint3Star({ active: isActive, data: data.data });
        return;
      case (stationId = "306"):
        setMidRangeStar({ active: isActive, data: data.data });
        return;
      case (stationId = "307"):
        setMidSideMid({ active: isActive, data: data.data });
        return;
      default:
        return;
    }
  };

  const handleDelete = (e, value) => {
    e.preventDefault();
    setPersonName((current) => _without(current, value));
    selectedplayer = selectedplayer.filter((val, index) => {
      return val !== value;
    });
    playerCount = playerCount - 1;
    getplayersAfterdelete(value);
  };

  const handleDeleteCollege = (e, value) => {
    e.preventDefault();
    setCName((current) => _without(current, value));
    selectedcollege = selectedcollege.filter((val, index) => {
      return val !== value;
    });
    collegeCount = collegeCount - 1;
    getcollegeAfterdelete(value);
  };

  const handleDeletePosition = (e, value) => {
    e.preventDefault();
    setPName((current) => _without(current, value));
    selectedposition = selectedposition.filter((val, index) => {
      return val !== value;
    });
    positionCount = positionCount - 1;

    getpositionAfterdelete(value);
  };

  const handleChangeTab = (event, newValue) => {
    setSelectedMiniTab(newValue); // added state for handling notes
    setSelectedTab(newValue);
  };

  const handleChangeIndex = (index) => {
    setSelectedMiniTab(index); // added state for handling notes
    setSelectedTab(index);
  };

  //... Export to excel functionality.
  const exportToExcelHandler = async () => {
    const sheetsData = [
      {
        sheetName: "Anthropometry",
        tables: getAnthropometryTablesForData(),
      },
      {
        sheetName: "Strength And Agility",
        tables: getSASTablesForData(),
      },
      {
        sheetName: "ShuttleRun - Laser Time",
        tables: getShuttleRunLaserTimeTablesForData(),
      },
      {
        sheetName: "Prolane-Gate Laser time",
        tables: getProLaneLaserTimeTablesForData(),
      },
      {
        sheetName: "3-4Run Gate Laser time",
        tables: getThreeFourLaserTimeTablesForData(),
      },
      {
        sheetName: "Shooting Drills",
        tables: getShootingDrillsTablesForData(),
      },
    ];

    await exportDataToExcel(sheetsData, generateExportToExcelFileName());
  };

  const generateExportToExcelFileName = () => {
    const EventDetails = JSON.parse(
      localStorage.getItem("commonEventList") || "[]"
    ).find((event) => event.leagueId === selectedEvent);

    return EventDetails
      ? `${EventDetails.eventYear}-${EventDetails.eventName}-Combine Result`
      : "Combine Result";
  };

  const getAnthropometryTablesForData = () => {
    const columnCount = isShowDEXABodyFat ? 22 : 21;

    return [
      {
        title: "",
        headerNames: [
          {
            title: `Player Name`,
            width: 40,
            style: styleHeaderCss,
          },
          {
            title: `Position`,
            width: 40,
            style: styleHeaderCss,
          },
          {
            title: `College Name`,
            width: 40,
            style: styleHeaderCss,
          },
          {
            title: `Standing Reach`,
            width: 30,
            style: styleHeaderCss,
          },
          {
            title: `Wingspan Dimensions`,
            width: 30,
            style: styleHeaderCss,
          },
          //   {
          //     title: `Height With Shoes`,
          //     width: 30,
          //     style: styleHeaderCss,
          //   },
          {
            title: `Height Without Shoes`,
            width: 30,
            style: styleHeaderCss,
          },
          {
            title: `Weight`,
            width: 30,
            style: styleHeaderCss,
          },
          {
            title: `Hand Dimensions-width`,
            width: 30,
            style: styleHeaderCss,
          },
          {
            title: `Hand Dimensions-length`,
            width: 30,
            style: styleHeaderCss,
          },
          // {
          //   title: `Body Fat`,
          //   width: 30,
          //   style: styleHeaderCss,
          // },
          // ...(isShowDEXABodyFat === "true"
          //   ? [
          //       {
          //         title: `DEXA Body Fat`,
          //         width: 30,
          //         style: styleHeaderCss,
          //       },
          //     ]
          //   : []),
          {
            title: `Hip Abduction Peak Force (L)`,
            width: 30,
            style: styleHeaderCss,
          },
          {
            title: `Hip Abduction Peak Force (R)`,
            width: 30,
            style: styleHeaderCss,
          },
          {
            title: `Hip Adduction Peak Force (L)`,
            width: 30,
            style: styleHeaderCss,
          },
          {
            title: `Hip Adduction Peak Force (R)`,
            width: 30,
            style: styleHeaderCss,
          },
          {
            title: `Knee Extension Peak Force (L)`,
            width: 30,
            style: styleHeaderCss,
          },
          {
            title: `Knee Extension Peak Force (R)`,
            width: 30,
            style: styleHeaderCss,
          },
          {
            title: `Knee Flexion Peak Force (L)`,
            width: 30,
            style: styleHeaderCss,
          },
          {
            title: `Knee Flexion Peak Force (R)`,
            width: 30,
            style: styleHeaderCss,
          },
          {
            title: `Ankle Plantar Flexion Peak Force (L)`,
            width: 30,
            style: styleHeaderCss,
          },
          {
            title: `Ankle Plantar Flexion Peak Force (R)`,
            width: 30,
            style: styleHeaderCss,
          },
        ],
        data:
          listAnthros && listAnthros.length > 0
            ? listAnthros.map((record) => {
                var handLength = "";
                var handwidth = "";
                var height = "";
                var heightwo = "";
                var sr = "";
                var wingspan = "";
                if (record.handLength !== "") {
                  handLength = getHandDimensionsUnitValue(record.handLength);
                }
                if (handLength === 0) {
                  handLength = "";
                }
                if (record.handWidth !== "") {
                  handwidth = getHandDimensionsUnitValue(record.handWidth);
                }
                if (handwidth === 0) {
                  handwidth = "";
                }
                if (
                  record.heightWithShoesFeet !== "" &&
                  record.heightWithShoesInches !== ""
                ) {
                  height = getLengthUnitValue(
                    record.heightWithShoesFeet,
                    record.heightWithShoesInches
                  );
                }
                if (height === "0'0''") {
                  height = "";
                }
                if (
                  record.heightWithOutShoesFeet !== "" &&
                  record.heightWithOutShoesInches !== ""
                ) {
                  heightwo = getLengthUnitValue(
                    record.heightWithOutShoesFeet,
                    record.heightWithOutShoesInches
                  );
                }
                if (heightwo === "0'0''") {
                  heightwo = "";
                }
                if (
                  record.standingReachFeet !== "" &&
                  record.standingReachInches !== ""
                ) {
                  sr = getLengthUnitValue(
                    record.standingReachFeet,
                    record.standingReachInches
                  );
                }
                if (sr === "0'0''") {
                  sr = "";
                }
                if (
                  record.wingSpanFeet !== "" &&
                  record.wingSpanInches !== ""
                ) {
                  wingspan = getLengthUnitValue(
                    record.wingSpanFeet,
                    record.wingSpanInches
                  );
                }
                if (wingspan === "0'0''") {
                  wingspan = "";
                }

                return {
                  playerName: `${record.playerName || ""} ${
                    record.trevisoText || ""
                  }`,
                  position: record.position ? record.position : "",
                  collegeOrClub: record.collegeOrClub
                    ? record.collegeOrClub
                    : "",
                  sr: sr,
                  wingspan: wingspan,
                  // height: height,
                  heightwo: heightwo,
                  bodyWeight: record.bodyWeight
                    ? getWeightUnitValue(record.bodyWeight)
                    : "",
                  handwidth: handwidth,
                  handLength: handLength,
                  // bodyFat: record.bodyFat ? record.bodyFat : "",
                  // ...(isShowDEXABodyFat === "true"
                  //   ? {
                  //       bodyFatDXA: record.bodyFatDXA ? record.bodyFatDXA : "-",
                  //     }
                  //   : ""),
                  hipAbductionPeakForceL: record?.hipAbductionPeakForceL || 0,
                  hipAbductionPeakForceR: record?.hipAbductionPeakForceR || 0,
                  hipAdductionPeakForceL: record?.hipAdductionPeakForceL || 0,
                  hipAdductionPeakForceR: record?.hipAdductionPeakForceR || 0,
                  kneeExtensionPeakForceL: record?.kneeExtensionPeakForceL || 0,
                  kneeExtensionPeakForceR: record?.kneeExtensionPeakForceR || 0,
                  kneeFlexionPeakForceL: record?.kneeFlexionPeakForceL || 0,
                  kneeFlexionPeakForceR: record?.kneeFlexionPeakForceR || 0,
                  AnklePlantarFlexionPeakForceL:
                    record?.anklePlantarFlexionPeakForceL || 0,
                  AnklePlantarFlexionPeakForceR:
                    record?.anklePlantarFlexionPeakForceR || 0,
                };
              })
            : [],
        columnStyles: Array(columnCount).fill({
          font: { size: 11 },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
          alignment: {
            horizontal: "center",
            vertical: "middle",
          },
        }),
      },
    ];
  };

  const getSASTablesForData = () => {
    return [
      {
        title: "",
        headerNames: [
          {
            title: `Player Name`,
            width: 40,
            style: styleHeaderCss,
          },
          {
            title: `Position`,
            width: 40,
            style: styleHeaderCss,
          },
          {
            title: `College Name`,
            width: 40,
            style: styleHeaderCss,
          },
          {
            title: `Lane Shuttle Left`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `Lane Shuttle Right`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `3/4 Court Sprint`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `Pro Lane`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `Max  Vertical Jump`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `Standing Vertical`,
            width: 20,
            style: styleHeaderCss,
          },
        ],
        data:
          listSAAgelity && listSAAgelity.length > 0
            ? listSAAgelity.map((record) => {
                const mvj = !["0", "undefined", undefined].includes(
                  record.maxVerticalLeap
                )
                  ? getHandDimensionsUnitValue(record.maxVerticalLeap)
                  : "";
                const sv = !["0", "undefined", undefined].includes(
                  record.standingVerticalLeap
                )
                  ? getHandDimensionsUnitValue(record.standingVerticalLeap)
                  : "";

                return {
                  playerName: `${record.playerName || ""} ${
                    record.trevisoText || ""
                  }`,
                  position: record.position || "",
                  bodyFat: record.collegeOrClub || "",
                  shuttleRunLeftTrialTime: record.shuttleRunLeftTrialTime || "",
                  shuttleRunRightTrialTime:
                    record.shuttleRunRightTrialTime || "",
                  threeFourRunTime: record.threeFourRunTime || "",
                  proLaneTrialTime: record.proLaneTrialTime || "",
                  mvj: mvj,
                  sv: sv,
                };
              })
            : [],
        columnStyles: Array(9).fill({
          font: { size: 11 },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
          alignment: {
            horizontal: "center",
            vertical: "middle",
          },
        }),
      },
    ];
  };

  const getShootingDrillsTablesForData = () => {
    return [
      {
        title: "",
        headerNames: [
          {
            title: `Player Name`,
            width: 40,
            style: styleHeaderCss,
          },
          {
            title: `Position`,
            width: 40,
            style: styleHeaderCss,
          },

          {
            title: `College Name`,
            width: 40,
            style: styleHeaderCss,
          },
          {
            title: `Spot Up Shooting`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `Side Mid Side Drill`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `Mid Side Mid Drill`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `Off The Dribble Shooting`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `Free Throws`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `3 Point Star Drill`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `Mid Range Star Drill`,
            width: 20,
            style: styleHeaderCss,
          },
        ],
        data:
          listShootingDrill && listShootingDrill.length > 0
            ? listShootingDrill.map((record) => {
                const SpotUpShooting = `${record.noOfMadeSpotup}/${record.maxCountSoptUp}`;
                const SMSDrill = `${record.noOfMadeSideMidSide}/${record.maxCountSideMidSide}`;
                const MSMDrill = `${record.noOfMadeMidSideMid}/${record.maxCountMidSideMid}`;
                const otds = `${record.noOfMadeOffTheDribble}/${record.maxCountOffTheDribble}`;
                const freethrows = `${record.noOfMadeFreeThrows}/${record.maxCountFreeThrows}`;
                const psdrill = `${record.noOfMade3PointStar}/${record.maxCount3PointStar}`;
                const msrdrill = `${record.noOfMadeMidRangeStar}/${record.maxCountMidRangeStar}`;

                return {
                  playerName: `${record.playerName || ""} ${
                    record.trevisoText || ""
                  }`,
                  position: record.position || "",
                  collegeOrClub: record.collegeOrClub || "",
                  SpotUpShooting: SpotUpShooting,
                  SMSDrill: SMSDrill,
                  MSMDrill: MSMDrill,
                  otds: otds,
                  freethrows: freethrows,
                  psdrill: psdrill,
                  msrdrill: msrdrill,
                };
              })
            : [],
        columnStyles: Array(10).fill({
          font: { size: 11 },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
          alignment: {
            horizontal: "center",
            vertical: "middle",
          },
        }),
      },
    ];
  };

  const getShuttleRunLaserTimeTablesForData = () => {
    return [
      {
        title: "",
        headerNames: [
          {
            title: `Player Name`,
            width: 30,
            style: styleHeaderCss,
          },
          {
            title: `LeftTrialTime`,
            width: 20,
            style: styleHeaderCss,
          },

          {
            title: `LeftLaserTime`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `RightTrialTime`,
            width: 20,
            style: styleHeaderCss,
          },
          {
            title: `RightLaserTime`,
            width: 20,
            style: styleHeaderCss,
          },
        ],
        data:
          laserTimeData?.shuttleRunLaserTime &&
          laserTimeData?.shuttleRunLaserTime.length > 0
            ? laserTimeData?.shuttleRunLaserTime.map((record) => {
                return {
                  playerName: record.playerName || "",
                  leftTrialTime: record.leftTrialTime || 0,
                  leftLaserTime: record.leftLaserTime || 0,
                  rightTrialTime: record.rightTrialTime || 0,
                  rightLaserTime: record.rightLaserTime || 0,
                };
              })
            : [],
        columnStyles: Array(5).fill({
          font: { size: 11 },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
          alignment: {
            horizontal: "center",
            vertical: "middle",
          },
        }),
      },
    ];
  };

  const getProLaneLaserTimeTablesForData = () => {
    return [
      {
        title: "",
        headerNames: [
          { title: `Player Name`, width: 30, style: styleHeaderCss },
          ...Array.from({ length: 8 }, (_, i) => ({
            title: `${i + 1}`,
            width: 10,
            style: styleHeaderCss,
          })),
          { title: `Total Laser Time`, width: 20, style: styleHeaderCss },
        ],
        data:
          laserTimeData?.proLaneLaserTime &&
          laserTimeData?.proLaneLaserTime.length > 0
            ? laserTimeData?.proLaneLaserTime.map((record) => {
                return {
                  playerName: record.playerName || "",
                  gate_1: record.gate_1 || 0,
                  gate_2: record.gate_2 || 0,
                  gate_3: record.gate_3 || 0,
                  gate_4: record.gate_4 || 0,
                  gate_5: record.gate_5 || 0,
                  gate_6: record.gate_6 || 0,
                  gate_7: record.gate_7 || 0,
                  gate_8: record.gate_8 || 0,
                  totalLaserTime: record.totalLaserTime || 0,
                };
              })
            : [],
        columnStyles: Array(10).fill({
          font: { size: 11 },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
          alignment: {
            horizontal: "center",
            vertical: "middle",
          },
        }),
      },
    ];
  };

  const getThreeFourLaserTimeTablesForData = () => {
    return [
      {
        title: "",
        headerNames: [
          { title: `Player Name`, width: 30, style: styleHeaderCss },
          ...Array.from({ length: 4 }, (_, i) => ({
            title: `${i + 1}`,
            width: 10,
            style: styleHeaderCss,
          })),
          { title: `Total Laser Time`, width: 20, style: styleHeaderCss },
        ],
        data:
          laserTimeData?.threeFourRunLaserTime &&
          laserTimeData?.threeFourRunLaserTime.length > 0
            ? laserTimeData?.threeFourRunLaserTime.map((record) => {
                return {
                  playerName: record.playerName || "",
                  gate_1: record.gate_1 || 0,
                  gate_2: record.gate_2 || 0,
                  gate_3: record.gate_3 || 0,
                  gate_4: record.gate_4 || 0,
                  totalLaserTime: record.totalLaserTime || 0,
                };
              })
            : [],
        columnStyles: Array(6).fill({
          font: { size: 11 },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
          alignment: {
            horizontal: "center",
            vertical: "middle",
          },
        }),
      },
    ];
  };

  return (
    <Container maxWidth={false}>
      <Grid container mt={1} mb={1} spacing={2}>
        <Grid item lg={3} sm={4} xs={6}>
          <Typography sx={{ fontSize: { xs: "0.6rem", lg: "1rem" } }}>
            Select Position
          </Typography>

          <FormControl sx={{ my: 0.5 }} size="small" fullWidth>
            <InputLabel id="demo-multiple-chip-label-pos">Position</InputLabel>
            <Select
              labelId="demo-multiple-chip-label-pos"
              id="demo-multiple-chip-pos"
              multiple
              value={pName}
              onChange={handleChangePosition}
              input={
                <OutlinedInput id="select-multiple-chip-pos" label="Chip" />
              }
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value, index) => (
                    <Chip
                      key={index}
                      label={value}
                      clickable
                      onDelete={(e) => {
                        handleDeletePosition(e, value);
                      }}
                      deleteIcon={
                        <CancelIcon onMouseDown={(e) => e.stopPropagation()} />
                      }
                    />
                  ))}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {positionName.map((name, index) => (
                <MenuItem
                  key={index}
                  value={name}
                  style={getStyles1(name, pName, theme)}
                >
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item lg={3} sm={4} xs={6}>
          <Typography sx={{ fontSize: { xs: "0.6rem", lg: "1rem" } }}>
            Select Players
          </Typography>

          <FormControl sx={{ my: 0.5 }} size="small" fullWidth>
            <InputLabel id="demo-multiple-chip-label"> Name</InputLabel>
            <Select
              labelId="demo-multiple-chip-label"
              id="demo-multiple-chip"
              multiple
              value={personName}
              onChange={handleChange}
              input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value, index) => (
                    <Chip
                      key={index}
                      label={value}
                      clickable
                      onDelete={(e) => {
                        handleDelete(e, value);
                      }}
                      deleteIcon={
                        <CancelIcon onMouseDown={(e) => e.stopPropagation()} />
                      }
                    />
                  ))}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {playerName.map((name, index) => (
                <MenuItem
                  key={index}
                  value={name}
                  style={getStyles(name, personName, theme)}
                >
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item lg={3} sm={4} xs={6}>
          <Typography sx={{ fontSize: { xs: "0.6rem", lg: "1rem" } }}>
            Select College
          </Typography>

          <FormControl sx={{ my: 0.5 }} size="small" fullWidth>
            <InputLabel id="demo-multiple-chip-label-college">
              College
            </InputLabel>
            <Select
              labelId="demo-multiple-chip-label-college"
              id="demo-multiple-chip-college"
              multiple
              value={cName}
              onChange={handleChangeCollege}
              input={
                <OutlinedInput id="select-multiple-chip-college" label="Chip" />
              }
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value, index) => (
                    <Chip
                      key={index}
                      label={value}
                      clickable
                      onDelete={(e) => {
                        handleDeleteCollege(e, value);
                      }}
                      deleteIcon={
                        <CancelIcon onMouseDown={(e) => e.stopPropagation()} />
                      }
                    />
                  ))}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {collegeName.map((name, index) => (
                <MenuItem
                  key={index}
                  value={name}
                  style={getStyles(name, cName, theme)}
                >
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Grid container pt={2} pb={2}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Grid container>
            <Grid item lg xs={12}>
              <Paper
                elevation={8}
                sx={{
                  borderRadius: "16px",
                }}
              >
                <Box
                  component="div"
                  display="flex"
                  flexGrow={1}
                  flexDirection="column"
                  className={classes.paperStyle}
                >
                  <AppBar
                    position="static"
                    className={classes.appbar}
                    sx={{
                      borderTopLeftRadius: "15px !important",
                      borderTopRightRadius: "15px !important",
                    }}
                  >
                    <Hidden mdUp>
                      <Tabs
                        scrollButtons
                        allowScrollButtonsMobile
                        value={selectedTab}
                        onChange={handleChangeTab}
                        indicatorColor="primary"
                        textColor="inherit"
                        variant="scrollable"
                        aria-label="full width tabs example"
                      >
                        <Tab
                          sx={{ textTransform: "none" }}
                          label="Anthropometry"
                          {...a11yProps(0)}
                        />
                        <Tab
                          sx={{ textTransform: "none" }}
                          label="Strength And Agility"
                          {...a11yProps(1)}
                        />
                        <Tab
                          sx={{ textTransform: "none" }}
                          label="Shooting Drills"
                          {...a11yProps(2)}
                        />
                        <Box className={classes.excelButton}>
                          {/* <ExcelFile
                            filename={"Combine Result"}
                            element={
                              <IconButton id="combineresult-list-excel-export"></IconButton>
                            }
                          >
                            <ExcelSheet
                              dataSet={sheetData.dataset}
                              name={sheetData.sheetName}
                              key={sheetData.key}
                            />
                            <ExcelSheet
                              dataSet={sheetDataSAA.dataset}
                              name={sheetDataSAA.sheetName}
                              key={sheetDataSAA.key}
                            />
                            <ExcelSheet
                              dataSet={sheetDataShootingDrill.dataset}
                              name={sheetDataShootingDrill.sheetName}
                              key={sheetDataShootingDrill.key}
                            />
                          </ExcelFile> */}
                          {!isWebView && (
                            <Button
                              size="small"
                              className={classes.exportToExcel}
                              title="Export to Excel"
                              sx={{
                                border: "1px solid lightgrey",
                                boxShadow: "1px 1px 3px black",
                                minWidth: "auto !important",
                              }}
                              onClick={exportToExcelHandler}
                            >
                              <img
                                alt="pngImg"
                                src="../../../../playerProfile/excel.png"
                                width="26"
                                height="26"
                              />
                            </Button>
                          )}
                        </Box>
                      </Tabs>
                    </Hidden>
                    <Hidden mdDown>
                      <Tabs
                        scrollButtons
                        allowScrollButtonsMobile
                        value={selectedTab}
                        onChange={handleChangeTab}
                        indicatorColor="primary"
                        textColor="inherit"
                        variant="standard"
                        aria-label="full width tabs example"
                      >
                        <Tab
                          sx={{ textTransform: "none" }}
                          label="Anthropometry"
                          {...a11yProps(0)}
                        ></Tab>
                        <Tab
                          sx={{ textTransform: "none" }}
                          label=" Strength And Agility"
                          {...a11yProps(1)}
                        />
                        <Tab
                          sx={{ textTransform: "none" }}
                          label="Shooting Drills"
                          {...a11yProps(2)}
                        />
                        <Box className={classes.excelButton}>
                          {/* <ExcelFile
                            filename={"Combine Result"}
                            element={
                              <IconButton id="combineresult-list-excel-export"></IconButton>
                            }
                          >
                            <ExcelSheet
                              dataSet={sheetData.dataset}
                              name={sheetData.sheetName}
                              key={sheetData.key}
                            />
                            <ExcelSheet
                              dataSet={sheetDataSAA.dataset}
                              name={sheetDataSAA.sheetName}
                              key={sheetDataSAA.key}
                            />
                            <ExcelSheet
                              dataSet={sheetDataShootingDrill.dataset}
                              name={sheetDataShootingDrill.sheetName}
                              key={sheetDataShootingDrill.key}
                            />
                          </ExcelFile> */}
                          <Button
                            size="small"
                            className={classes.exportToExcel}
                            title="Export to Excel"
                            sx={{
                              border: "1px solid lightgrey",
                              boxShadow: "1px 1px 3px black",
                              minWidth: "auto !important",
                            }}
                            onClick={exportToExcelHandler}
                          >
                            <img
                              alt="pngImg"
                              src="../../../../playerProfile/excel.png"
                              width="26"
                              height="26"
                            />
                          </Button>
                        </Box>
                      </Tabs>
                    </Hidden>
                  </AppBar>
                  <SwipeableViews
                    className={classes.swipeView}
                    axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                    index={selectedTab}
                    onChangeIndex={handleChangeIndex}
                  >
                    {/* Tab 1 */}
                    <TabPanel
                      value={selectedTab}
                      index={0}
                      dir={theme.direction}
                    >
                      <CombineResultsAnthros
                        favPlayersASAData={favPlayersAnthrosData}
                        favPlayersASADataselected={
                          favPlayersAnthrosDataSelected
                        }
                        playerAnthrosAndStrengthAgiltyColumns={
                          playerAnthrosAndStrengthAgiltyColumns
                        }
                        Showval={Showval}
                        notes={notes}
                        loading={loading}
                        bodyFat={bodyFat}
                        handDimentions={handDimentions}
                        weight={weight}
                        heightWithShoes={heightWithShoes}
                        heightWithoutShoes={heightWithoutShoes}
                        standingReach={standingReach}
                        wingSpanDimentions={wingSpanDimentions}
                        eventId={eventId}
                        lengthUnits={lengthUnits}
                        weightUnits={weightUnits}
                        setWeightUnits={setWeightUnits}
                        setLengthUnits={setLengthUnits}
                        getWeightUnitValue={getWeightUnitValue}
                        getLengthUnitValue={getLengthUnitValue}
                        getLengthUnitLabelType={getLengthUnitLabelType}
                        getWeightUnitLabelType={getWeightUnitLabelType}
                        getHandDimensionsUnitValue={getHandDimensionsUnitValue}
                        getHandDimensionsUnitLabelType={
                          getHandDimensionsUnitLabelType
                        }
                        dXABodyFat={dXABodyFat}
                        isShowDEXABodyFat={isShowDEXABodyFat}
                        selectedTab={selectedTab}
                        isWebView={isWebView}
                      />
                    </TabPanel>

                    <TabPanel
                      value={selectedTab}
                      index={1}
                      dir={theme.direction}
                    >
                      <CombineResultsSAA
                        favPlayersASAData={favPlayersSAAgilityData}
                        favPlayersASADataselected={
                          favPlayersSAAgilityDataSelected
                        }
                        playerAnthrosAndStrengthAgiltyColumns={
                          playerAnthrosAndStrengthAgiltyColumns
                        }
                        Showval={Showval}
                        notes={notes}
                        loading={loading}
                        laneShuttleLeft={laneShuttleLeft}
                        laneShuttleRight={laneShuttleRight}
                        threeFour={threeFour}
                        proLane={proLane}
                        maxVerticalJump={maxVerticalJump}
                        standingVerticalJump={standingVerticalJump}
                        eventId={eventId}
                        lengthUnits={lengthUnits}
                        getHandDimensionsUnitValue={getHandDimensionsUnitValue}
                        getHandDimensionsUnitLabelType={
                          getHandDimensionsUnitLabelType
                        }
                        selectedTab={selectedTab}
                        isWebView={isWebView}
                      />
                    </TabPanel>
                    <TabPanel
                      value={selectedTab}
                      index={2}
                      dir={theme.direction}
                    >
                      <CombineResultShootingDrills
                        favPlayersShootingDrillData={
                          favPlayersShootingDrillData
                        }
                        playerShootingDrillsColumns={
                          playerShootingDrillsColumns
                        }
                        favPlayersShootingDrillDataselected={
                          favPlayersShootingDrillDataselected
                        }
                        Showval={Showval}
                        notes={notes}
                        loading={loading}
                        spotUp={spotUp}
                        sideMidSide={sideMidSide}
                        midSideMid={midSideMid}
                        offTheDribble={offTheDribble}
                        freeThrows={freeThrows}
                        point3Star={point3Star}
                        midRangeStar={midRangeStar}
                        eventId={eventId}
                        selectedTab={selectedTab}
                        isWebView={isWebView}
                      />
                    </TabPanel>
                  </SwipeableViews>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}
